if (document.location.href.indexOf('videoask') > 0 ) {
	window.addEventListener("load", (event) => {
		// Hide HubSpot
		document.getElementById('hubspot-messages-iframe-container').style.visibility = 'hidden';

		// Add VideoAsk
		window.VIDEOASK_EMBED_CONFIG = {
			"kind": "widget",
			"url": "https://www.videoask.com/fwfb5qyd1",
			"options": {
				"widgetType": "VideoThumbnailExtraLarge",
				"text": "",
				"backgroundColor": "#026451",
				"position": "bottom-right",
				"dismissible": true
			}
		}
		var scriptTag = document.createElement('script');
		scriptTag.src = 'https://www.videoask.com/embed/embed.js';
		document.body.appendChild(scriptTag);

		// Track what is happening in VideoAsk
		window.addEventListener('message', function(message){ 
			if (message.origin != 'https://www.videoask.com') {
				return
			}
			console.log(message)		
			if (message.data.optionId == '81adf7c4-37ec-4518-934e-ed48a4c24a70') {
				triggerBot()
			}
		}) 

		function triggerBot() {
			// Hide VideoAsk widget and show HubSpot
			document.getElementById('videoaskModalWrapper').style.display = 'none';
			document.getElementById('videoaskModalWrapper').remove()
			document.getElementsByClassName('videoask-embed__button--SgLKO')[0].style.display = 'none';
			document.getElementById('hubspot-messages-iframe-container').style.display = 'block';
			document.getElementById('hubspot-messages-iframe-container').style.visibility = 'visible';

			// Switch to the correct bot
			window.history.pushState({}, 'livebot', '?livebot=true'); 
			window.HubSpotConversations.widget.refresh({openToNewThread: true});
			setTimeout(function(){
				window.HubSpotConversations.widget.open();
			},200);
			setTimeout(function(){
				window.HubSpotConversations.widget.open();
			},400);	
			setTimeout(function(){
				window.HubSpotConversations.widget.open();
			},800);
	
		}
	});
}